//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import {
  faGavel,
  faBorderBottomRight,
  faFileCertificate,
} from '@fortawesome/pro-regular-svg-icons';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';
import AuthMixin from '@motionelements/core/src/components/mixins/auth.mixin.js';

export default {
  name: 'UserGuidePage',
  mixins: [AuthMixin],
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    AboutTabs: () => import('@/components/about/AboutTabs.vue'),
    SavingContent: () => import('@/components/user-guide/SavingContent.vue'),
    PurchasingSection: () => import('@/components/user-guide/PurchasingSection.vue'),
    CardSection: () => import('@/components/core/elements/CardSection.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  data() {
    return {
      searching: [
        {
          heading: this.$t('user_guide.ai_search_heading'),
          text: this.$t(this.$wbr('user_guide.ai_search_text')),
          link: this.$link('https://help.motionelements.com/docs/use-visualsearch-for-video-image-templates').url(),
          image: 'https://static.moele.me/img/channels2022/user-guide/ai-search.png?auto=format&w=630',
        },
        {
          heading: this.$t('user_guide.keyword_search_heading'),
          text: this.$t(this.$wbr('user_guide.keyword_search_text')),
          link: this.$link('https://help.motionelements.com/docs/how-to-search-for-stock-content').url(),
          image: 'https://static.moele.me/img/channels2022/user-guide/keyword-search.png?auto=format&w=630',
        },
        {
          heading: this.$t('user_guide.category_search_heading'),
          text: this.$t(this.$wbr('user_guide.category_search_text')),
          image: 'https://static.moele.me/img/channels2022/user-guide/begin-category-search.221205.png?auto=format&w=630',
        },
        {
          heading: this.$t('term.filters'),
          text: this.$t(this.$wbr('user_guide.filters_text')),
          image: 'https://static.moele.me/img/channels2022/user-guide/filters.png?auto=format&w=630',
        },
      ],
      exampleElements: [
        {
          icon: faGavel,
          iconBg: 'bg-pink',
          title: this.$t('nav.eula'),
          text: this.$t(this.$wbr('user_guide.licensing_text')),
        },
        {
          icon: faBorderBottomRight,
          iconBg: 'bg-success-700',
          title: this.$t('term.free_converter'),
          text: this.$t(this.$wbr('user_guide.free_converter_text')),
        },
        {
          icon: faFileCertificate,
          iconBg: 'bg-warning-600',
          title: this.$t('term.license_certificate'),
          text: this.$t(this.$wbr('user_guide.license_certificate_text')),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    pageTitle() {
      return this.$t('nav.user_guide');
    },
    pageDescription() {
      return this.$t('licensing.page_description_{count}', { count: renderContentCount(this, publishedContentCounts.total.element) });
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.user_guide'),
          link: this.$link('/begin').fullPath(),
          active: true,
        },
      ];
    },
  },
};
